import { render, staticRenderFns } from "./baseBottom.vue?vue&type=template&id=12877436&scoped=true&"
import script from "./baseBottom.vue?vue&type=script&lang=js&"
export * from "./baseBottom.vue?vue&type=script&lang=js&"
import style0 from "./baseBottom.vue?vue&type=style&index=0&id=12877436&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12877436",
  null
  
)

export default component.exports